import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import logoWhite from '../../../assets/images/sp-logo.svg';
import logoBlack from '../../../assets/images/sp-logo-black.svg';
import pinBlack from '../../../assets/images/pin-black.svg';
import MobileMenu from './MobileMenu';
import { hamburger } from './icons';
import { NAVIGATION_MOBILE_HEIGHT } from '../../../styles/variables.style';

const Header = styled.div`
  align-items: center;
  background-color: ${({ top }) => (top ? 'unset' : '#f5f5f5')};
  display: flex;
  height: ${NAVIGATION_MOBILE_HEIGHT}px;
  justify-content: space-between;
  padding: 0 15px;
  transition: background-color 300ms ease-in-out;
`;

const LogoContainer = styled.div`
  height: 25px;
  position: relative;
`;

const Logo = styled.img`
  position: absolute;
  left: 0;
  height: 100%;
  top: 0;
`;

const LogoWhite = Logo.extend`
  opacity: ${({ white }) => (white ? '1' : '0')};
  transition: opacity 0.3s;
`;

const LogoBlack = Logo.extend`
  opacity: ${({ white }) => (white ? '0' : '1')};
  transition: opacity 0.3s;
`;

const RightItems = styled.div`
  display: flex;
  align-items: center;
`;

const LocatorIcon = styled.img`
  width: 18px;
  height: 25px;
  margin-right: 24px;
  margin-bottom: 1px;
`;

const Hamburger = styled.div`
  background-image: url(${hamburger});
  background-size: contain;
  cursor: pointer;
  filter: ${({ white }) => (white ? 'invert(1)' : 'invert(0)')};
  height: 16px;
  width: 16px;
`;

class MobileHeader extends React.Component {
  static defaultProps = {
    onlyLogo: false,
    white: false,
  };

  static propTypes = {
    locale: PropTypes.string.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }).isRequired,
    top: PropTypes.bool.isRequired,
    onlyLogo: PropTypes.bool,
    white: PropTypes.bool,
  };

  state = {
    open: false,
  };

  openMenu = () => {
    this.setState({ open: true });
  };

  closeMenu = () => {
    this.setState({ open: false });
  };

  render() {
    const { open } = this.state;
    const { locale, location, top, onlyLogo, white } = this.props;

    return (
      <Header top={top}>
        <a href={`https://www.shiseido-professional.com/${locale}`}>
          <LogoContainer>
            <LogoWhite src={logoWhite} white={top && white} />
            <LogoBlack src={logoBlack} white={top && white} />
          </LogoContainer>
        </a>
        {!onlyLogo && (
          <RightItems>
            {!location.pathname.match(/salon-locator/) && (
              <Link to={`/${locale}/salon-locator`} href={`/${locale}/salon-locator`}>
                <LocatorIcon src={pinBlack} />
              </Link>
            )}
            <Hamburger onClick={this.openMenu} white={top && white} />
            <MobileMenu open={open} isFooterMenu={false} closeMenu={this.closeMenu} />
          </RightItems>
        )}
      </Header>
    );
  }
}

const mapState = state => ({
  locale: state.locale,
});

export default connect(mapState)(MobileHeader);



// WEBPACK FOOTER //
// ./src/components/GlobalMenu/Mobile/MobileHeader.js